import React, { useEffect } from "react";
interface IFeedobellProps {
  projectId: string;
  userId?: string;
}
export const Feedobell: React.FC<IFeedobellProps> = ({projectId, userId}) => {
  useEffect(() => {
    // Dynamically load the CDN module
    // @ts-ignore
    import("https://sdk.feedobell.com")
      .then(() => {
      })
      .catch((err) => {
        console.error("Failed to load Feedobell:", err);
      });
  }, []);
// @ts-expect-error As it is a custom element
return <feedobell-widget project-id={projectId} user-id={userId} /> ;
};

       